import React from "react";
import appStoreIcon from "../../assets/images/app-store-icon.png";
import "./Buttons.css";
import { useTranslation } from "react-i18next";
const DownloadOnAppStore = () => {
  const { t } = useTranslation();
  return (
    <>
      <a href="##" className="main-download-button">
        <div className="mobile-button-flex">
          <div className="download-icon-mobile">
            <img src={appStoreIcon} alt="Google Play Icon" />
          </div>
          <div className="download-text-mobile">
            <p>
              {t("Download")} {t("on")}
            </p>
            <h5>Apple Store</h5>
          </div>
        </div>
      </a>
    </>
  );
};

export default DownloadOnAppStore;
